import React from "react";
import {
  Article,
  Section,
  SectionHeader,
  Skills,
} from "../../styles/ResumeStyles";

const Objective = () => {
  return (
    <Article>
      <Section>
        <SectionHeader>
          <p className="bold">Objective</p>
        </SectionHeader>
        <div>
          <ul>
            As a full-stack web developer and designer, I am committed to
            creating exceptional digital product experiences through design and
            development. I am an ardent learner, always seeking opportunities to
            enhance my skills and tackle new challenges.
          </ul>
        </div>
      </Section>

      <Section>
        <SectionHeader>
          <p className="bold">Skills</p>
        </SectionHeader>
        <div>
          <Skills>
            {[
              "html",
              "css",
              "javascript",
              "typescript",
              "nodejs",
              "react",
              "redux",
              "mongodb",
              "express",
              "aws",
            ].map((item) => (
              <p>{item}</p>
            ))}
          </Skills>
          <ul>
            <li>
              Proficient in React, NodeJS, Redux, MongoDB, AWS, and other web
              development technologies
            </li>
            <li>
              Skilled in user interface design, wireframing, and prototyping
            </li>
          </ul>
        </div>
      </Section>
    </Article>
  );
};

export default Objective;
